export default "__VITE_PUBLIC_ASSET__65a78ad4__"